import { api } from '@/lib/api';
import { Tenant } from '@activepieces/shared';

export const tenantApi = {
  list() {
    return api.get<Tenant[]>('/v1/tenants/user/tenants');
  },
  current: async () => {
    return api.get<Tenant>('/v1/tenants/current');
  },
};
